export default __webpack_public_path__ + "static/media/maxiscreen.5050805a.svg";